import { Button } from '@montugroup/design-system';
import { ALT_CUSTOMER_SERVICE_NUMBER_DISPLAY, ALT_CUSTOMER_SERVICE_NUMBER_INTL } from '@montugroup/frontend-common';
import { alternaleaf, BrandThemeProvider } from '@montugroup/themes';
import ErrorIcon from '@mui/icons-material/Error';
import { Box, Link, Typography } from '@mui/material';

function ErrorFallback() {
  return (
    <BrandThemeProvider theme={alternaleaf}>
      <Box
        role="alert"
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          mt: 30,
          p: 2,
        }}
      >
        <Box
          sx={{
            textAlign: 'center',
          }}
        >
          <ErrorIcon color="error" sx={{ fontSize: 60 }} />
          <Typography variant="h4" component="h1">
            Something went wrong
          </Typography>
          <Typography
            variant="body1"
            sx={{
              my: 2,
            }}
          >
            There was a problem processing the request. Please try again.
          </Typography>
          <Typography variant="body1">
            If the problem persists, please contact us at
            <Link href={`tel:${ALT_CUSTOMER_SERVICE_NUMBER_INTL}`}>{ALT_CUSTOMER_SERVICE_NUMBER_DISPLAY}</Link>
          </Typography>
          <Box
            sx={{
              mt: 10,
            }}
          >
            <Button onClick={() => window.location.reload()}>Reload</Button>
          </Box>
        </Box>
      </Box>
    </BrandThemeProvider>
  );
}

export default ErrorFallback;
